
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registrazione",
      function () {
        return require("private-next-pages/registrazione/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registrazione"])
      });
    }
  